export default __webpack_public_path__ + "static/media/sms_slide0.502fa63c.jpg";